import { DEFAULT_FILTERS, PRODUCT_CATEGORIES_BY_PERSON, PRODUCT_CATEGORY_ALIAS } from '@constants/filters';
import { ITagOption } from '@interfaces/productTags';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type IState = {
  activeCategory: PRODUCT_CATEGORIES_BY_PERSON;
  list: {
    [category in PRODUCT_CATEGORIES_BY_PERSON]?: {
      alias: string;
      options: ITagOption[];
    };
  };
};

const productTagsSlice = createSlice({
  name: 'productTags',
  initialState: {
    activeCategory: DEFAULT_FILTERS.productCategoryByPerson,
    list: {},
  },
  reducers: {
    setProductOptions: (
      state,
      {
        payload,
      }: PayloadAction<{
        productCategoryByPerson: PRODUCT_CATEGORIES_BY_PERSON;
        tagsOptions: ITagOption[];
        alias: PRODUCT_CATEGORY_ALIAS;
      }>,
    ) => {
      state.list = {
        ...state.list,
        [payload.productCategoryByPerson]: {
          options: payload.tagsOptions,
          alias: payload.alias,
        },
      };
    },
    setVisibleActiveProductCategory: (state, { payload }: PayloadAction<PRODUCT_CATEGORIES_BY_PERSON>) => {
      state.activeCategory = payload;
    },
  },
});

const { actions, reducer } = productTagsSlice;

export const { setProductOptions, setVisibleActiveProductCategory } = actions;

export default reducer;
